import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { fontFamily, lineHeight } from "@styles/type.styles";
import { colors, greys, headerColor } from "@styles/color.styles";
import { size } from "@styles/type.styles";

export const dialog = {
  header: {
    fontFamily,
    marginTop: 20,
    marginBottom: 15,
    fontSize: "22px",
    fontWeight: "bold",
    lineHeight: lineHeight.std,
    color: headerColor,
  } as CSSProperties,
  description: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    marginBottom: 15,
  } as CSSProperties,
  listItem: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    display: "flex",
    marginBottom: 10,
  } as CSSProperties,
  bullet: {
    fontSize: 18,
    fontWeight: "bold",
    color: colors.green.standard,
    marginRight: 10,
  } as CSSProperties,
  label: {
    marginTop: 3,
  } as CSSProperties,
  learnMore: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    marginTop: 20,
    marginBottom: 0,
  } as CSSProperties,
};

export const styles = {
  buttonLabelStyle: {
    paddingTop: 4,
  },
};
